import styled from 'styled-components';

import ThemeHelper from '@themes/theme-helper';

export const HeaderTitle = styled.span(props => {
  const { width = '20%' } = props;
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${width};
    padding: 3px;
    margin: 0px 5px;
    border-bottom: 2px solid ${colours.grey[200]};
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
  `;
});

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: sticky;
  top: 0;

  box-sizing: border-box;
  background-color: white;
  padding-bottom: 5px;
  width: 100%;
`;

export const CheckboxWrapper = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
      padding: 1px 8px;
      margin: 0px 5px;
      border-bottom: 2px solid ${colours.grey[200]};

      div {
        border: 1px solid ${colours.grey[200]};
        border-radius: 2px;
      }
  `;
});

export const SortableHeader = styled(HeaderTitle)(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    width: 40%;
    user-select: none;
    cursor: pointer;

    svg {
      path {
        fill: ${colours.grey[700]};
      }
    }
  `;
});

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SvgWrapper = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    path {
      fill: ${props.status ? colours.grey[1000] : 'black'} !important;
    }
  `;
});

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 245px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;

  height: 245px;
  overflow-y: auto;
`;

export const IconContainer = styled.div`
  margin-left: 10px;

  > div {
    height: 20px;
  }
`;
